import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID } from 'utils/types';
import css from './PeopleResults.css';
import Title from 'common/Title';
import ConnectionsList from '../home/connections/ConnectionsList';

export default class PeopleResults extends React.Component {
  render() {
    if ( this.props.connections.length === 0 ) return null;
    return (
      <div className={css['people-results-container']}>
        <Title text="People" lineHeight="24px" />
        <ConnectionsList connections={this.props.connections} />
      </div>
    );
  }
}

PeopleResults.propTypes = {
  connections: PropTypes.arrayOf(PropTypes.shape({
    personId: SFEntityID.isRequired,
    fullName: PropTypes.string.isRequired,
    email: PropTypes.string,
    phoneNumber: PropTypes.string,
    photoAvailable: PropTypes.bool,
    onlineSchedulingAvailable: PropTypes.bool,
    roles: PropTypes.array.isRequired
  })).isRequired
};
